import { Edition as MarketplaceEdition } from '@vendasta/marketplace-apps/v1';
import { Edition, ItemSelectorRowItem, SelectedItem } from '../interface';
import { findItem } from './item';

export function convertToItemSelectorEdition(marketplaceEdition: MarketplaceEdition): Edition {
  const editionId = marketplaceEdition?.editionId ? marketplaceEdition?.editionId : '';
  return {
    appId: marketplaceEdition?.appId,
    name: marketplaceEdition?.name,
    editionId: editionId,
  };
}

export function areEditionIdsEqual(input1: string | null | undefined, input2: string | null | undefined): boolean {
  // Pro editions of O&O products are represented by an empty edition ID
  const editionId1 = input1 ?? '';
  const editionId2 = input2 ?? '';
  return editionId1 === editionId2;
}

export function findItemEdition(item: SelectedItem | null, editions: Edition[]): Edition | null {
  if (!editions?.length) return null;

  if (item?.type !== 'app' || !item?.edition) {
    return editions[0];
  }

  return (
    editions.find((edition) => {
      const nullishMatch = !edition?.editionId && !item.edition?.editionId;
      const stringMatch = edition?.editionId === item.edition?.editionId;
      return nullishMatch || stringMatch;
    }) ?? null
  );
}

export function markActiveEdition(
  selectedItems: SelectedItem[],
  immutableSelectedItems: SelectedItem[],
  activatableItem: ItemSelectorRowItem,
): ItemSelectorRowItem {
  const [selected] = findItem(selectedItems, activatableItem.itemId);
  const [immutableItem] = findItem(immutableSelectedItems, activatableItem.itemId);

  const activeEdition = immutableItem ? findItemEdition(immutableItem, activatableItem.editions ?? []) : null;
  const selectedEdition = selected ? findItemEdition(selected, activatableItem.editions ?? []) : null;

  // selectedEdition takes precedence over the activeEdition when setting editionId for an item
  if (activeEdition && !selectedEdition) {
    activeEdition.isActive = true;
    activatableItem.editionId = activeEdition.editionId;
  }
  if (selectedEdition) {
    activatableItem.editionId = selectedEdition.editionId;
  }

  return activatableItem;
}
